import {Component, computed, OnInit, signal} from '@angular/core';
import {RpService} from "../../services/rp.service";
import {RpReq} from '../../interfaces/tipos';
import Swal from "sweetalert2";
import {DialogModule} from "primeng/dialog";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {Button} from "primeng/button";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {InputMaskModule} from "primeng/inputmask";
import {DropdownModule} from "primeng/dropdown";
import {TooltipModule} from "primeng/tooltip";

@Component({
    selector: 'app-rp-create-dlg',
    standalone: true,
    imports: [
        DialogModule,
        FormsModule,
        InputTextModule,
        Button,
        InputMaskModule,
        DropdownModule,
        TooltipModule
    ],
    templateUrl: './rp-create-dlg.component.html'
})
export class RpCreateDlgComponent implements OnInit {
    loading = signal(false);
    display = computed(() => this.rpService._openDlg());
    selected: RpReq = {} as RpReq;
    instituciones = [
        {name: 'MIVI'},
        {name: 'SIGET'},
        {name: 'Ministerio de Cultura'},
        {name: 'MARN'}
    ];

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }

    constructor(protected rpService: RpService, private ls: LoginServices) {
    }

    create() {
        if (!this.validateForm()) {
            return;
        }
        this.selected.usuario = this.ls.session()?.perfil.usuario!
        if (this.selected.institucion && typeof this.selected.institucion !== 'string') {
            this.selected.institucion = this.selected.institucion.name; // Extract only the name
        }

        this.rpService.create(this.selected)
            .subscribe({
                next: (result) => {
                    if (result) {
                        Swal.fire({
                            text: "Registro procesado correctamente",
                            icon: "success"
                        });
                    }
                },
                error: (error) => {
                    console.log(error)
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: 'Ocurrió un error al procesar',
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`
                    });
                    this.closeDlg()
                },
                complete: () => {
                    this.closeDlg()
                }
            });
    }

    validateForm(): boolean {
        if (!this.selected.institucion || !this.selected.numDocumento || !this.selected.profesion ||
            !this.selected.nombres || !this.selected.apellidos || !this.selected.numResolucion ||
            !this.selected.fechaResolucion || !this.selected.fechaVencimiento) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos requeridos',
                text: 'Por favor complete todos los campos requeridos.',
            });
            return false;
        }
        return true;
    }

    closeDlg() {
        this.selected = {} as RpReq;
        this.rpService._openDlg.set(false)
    }

}
